export function roundToNearestMultipleOfN(number: number, n: number) {
  return Math.round(number / n) * n;
}
